import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { HeaderModule } from '../../../shared/component/common/header/header.module';
import { ButtonModule } from '../../../shared/component/common/button/button.module';
import { LabelModule } from '../../../shared/component/common/label/label.module';
import { ListStatusModule } from '../../../shared/component/common/list-status/list-status.module';
import { OverviewUserDataNotEditableComponent } from './overview-user-data-not-editable.component';
import { LoadingCircleModule } from '../../../shared/component/common/loading-circle/loading-circle.module';
import { IdsModule } from '../../../ids.module';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
    IdsModule
  ],
  declarations: [OverviewUserDataNotEditableComponent]
})
export class OverviewUserDataNotEditableModule {}
